<template>
  <div id="app">
    <h1>FLuiD GrOtTo</h1>

    <transition name="fade">
      <div v-if="splash">
        <transition name="fade">
          <h2 v-if="splash && splash1">"I'm gunna add and send 500 close up photos of my asshole"</h2>
        </transition>
        <transition name="fade">
          <h2 v-if="splash && splash2">"Each one I will pour a different liquid down my crack"</h2>
        </transition>
      </div>

      <div v-else>
        <transition name="slide">
          <p v-if="fluid !== ''" :key="fluid">{{ fluid + '.' }}</p>
        </transition>
      </div>
    </transition>

    <transition name="fade">
`    <button v-if="!splash" @click="generateFluid">Generate Fluid</button>
    </transition>
  </div>
</template>

<script>
import { setInterval } from 'timers';
export default {
  name: 'app',
  data() {
    return {
      fluids: require('./assets/fluids.json'),
      descriptors: require('./assets/descriptors.json'),
      fluid: '',
      recentFluids: [],
      splash: true,
      splash1: false,
      splash2: false,
    }
  },
  created() {
    setTimeout(() => {
      this.splash1 = true;
    }, 500);

    setTimeout(() => {
      this.splash1 = false;
    }, 3000);

    setTimeout(() => {
      this.splash2 = true;
    }, 4000);

    setTimeout(() => {
      this.splash2 = false;
    }, 6000);

    setTimeout(() => {
      this.splash = false;
      this.generateFluid();
    }, 7000);
  },
  methods: {
    generateFluid() {
      let descriptor = this.descriptors[Math.floor(Math.random() * this.descriptors.length)];

      const array = descriptor.split('%');

      array.forEach((segment, index) => {
        descriptor = descriptor.replace('%' + (index + 1), this.randomFluid());
      });

      this.fluid = descriptor;
      this.recentFluids.push(this.fluid);
    },
    randomFluid() {
      return this.fluids[Math.floor(Math.random() * this.fluids.length)];
    }
  }
}
</script>

<style lang="scss">
body {
  min-height: 100vh;
  font-family: 'Patrick Hand', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #FFF;
  background-color: #2c3e50;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 80vh;
  width: 100%;
  overflow: hidden;

  > div {
    width: 80%;
    max-width: 32em;
    position: relative;
    height: 100%;
  }
}

h1 {
  font-family: 'Nosifer', Helvetica, Arial, sans-serif;
}

h2, p {
  font-size: 2em;
  text-align: center;
  position: absolute;
  width: 100%;
  opacity: .8;
  top: 50%;
  transform: translateY(-50%);
  margin: 0;

  &:first-letter {
    text-transform: uppercase;
  }
}

h2 {
  font-size: 3em;
}

button {
  background-color: rgba(255,255,255,.5);
  border: 0;
  padding: .5em 1em;
  font-size: 2em;
  font-family: inherit;
  text-transform: uppercase;
  color: #FFF;
  cursor: pointer;
  transition: all .2s;
  outline: none;

  &:hover {
    background: rgba(255,255,255,.75);
  }

  &:active {
    background: rgba(255,255,255,.25);
  }
}

.slide {
  &-enter-active, &-leave-active {
    transition: all .5s;
  }

  &-enter {
    transform: translateY(100%);
    opacity: 0;
  }

  &-leave-to {
    opacity: 0;
    transform: translateY(-100%);
  }
}

.fade {
  &-enter-active, &-leave-active {
    transition: all 1s;
  }

  &-enter {
    opacity: 0;
  }

  &-leave-to {
    opacity: 0;
  }
}
</style>
